import { jsx as _jsx } from "react/jsx-runtime";
import { Root, Avatar } from "./AvatarButton.components.js";
export const AvatarButtonAtomComponent = ({ avatarProps, ...props }) => (_jsx(Root, { "data-testid": "AvatarButton", ...props, children: _jsx(Avatar, { ...avatarProps, "data-testid": "AvatarButtonAvatar" }) }));
export default AvatarButtonAtomComponent;
